import Link from "next/link";
import { FC } from "react";

type Props = {
  label: string;
  href: string;
};

const SearchLink: FC<Props> = ({ href, label }): JSX.Element => {
  return (
    <Link
      href={href}
      className="block border border-gray-100 px-16 py-12 rounded-full text-sm space-x-8 hover:no-underline hover:bg-gray-100 bg-white"
    >
      <i className="icon icon-Search" />
      <span>{label}</span>
    </Link>
  );
};

export default SearchLink;
